/**
 * 注册分销 列表
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2022, all rights reserved. Essa.cn
 */
import React from 'react';
import {Popover, Space, Spin, Avatar,Badge,Select } from "antd";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import HoverIcon from "@components/HoverIcon";
import IconFont from "@components/IconFont";
import SearchForm from '@components/SearchForm/SearchForm';
import { toFixedWithCommas,} from "@utils/number-util";
import { isEmptyObject,isEmpty} from "@utils/utils";
import "./List.less";
import {Link} from "react-router-dom";
import dayjs from "dayjs";
const { Option } = Select;
class DistributorList extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            initialSearch:{
                type:'0', // 注册提成	0,订单提成	1
                status:'VALID', // 启用中	VALID,已停用	INVALID,未启用	NOT_ENABLED
            },//默认搜索
            searchFormOptions:[
                {
                    name:'time',
                    cnTitle:'推广时间',
                    cnTitleId:'TuiGuangShiJian ',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['createTimeStart','createTimeEnd'],
                    type:'DateRangePicker',
                    col:12,
                },
                // {
                //     name:'saleMarketId',
                //     cnTitle:'销售区域',
                //     cnTitleId:'XiaoShouQuYu',
                //     cnPlaceholder:'销售区域',
                //     cnPlaceholderId:'XiaoShouQuYu',
                //     showSubTitle:Lang({id:"GuoJia",default:'国家'}),
                //     type:'Region',
                //     col:24,
                // },
                {
                    name:'type',
                    cnTitle:'分销类型',
                    cnTitleId:'FenXiaoLeiXing',
                    cnPlaceholder:'分销类型',
                    cnPlaceholderId:'FenXiaoLeiXing',
                    type:'Enum',
                    enumCanAll:true,
                    enumClass:'fx_user_type',
                    width: 250,
                },
                {
                    name:'status',
                    cnTitle:'账户状态',
                    cnTitleId:'ZhangHuZhuangTai',
                    cnPlaceholder:'账户状态',
                    cnPlaceholderId:'ZhangHuZhuangTai',
                    type:'Enum',
                    enumCanAll:true,
                    enumClass:'fx_user_status',
                    width: 250,
                },
                {
                    name:'distributor',
                    cnTitle:'分销商',
                    cnTitleId:'FenXiaoShang',
                    cnPlaceholder:'分销商名称/账号',
                    cnPlaceholderId:'FenXiaoShangMingChengZhangHao',
                },
                {
                    name:'inviter',
                    cnTitle:'推荐人',
                    cnTitleId:'TuiJianRen',
                    cnPlaceholder:'推荐人',
                    cnPlaceholderId:'TuiJianRen',
                },
            ],
            columns:[
                {
                    cnTitle: '分销商',
                    dataIndex: 'name',
                    width:200,
                    cnTitleId: 'FenXiaoShang',
                    render: (name, record) => {
                        const iconUrl = require('../../../assets/img/country/'+record.abbreviate + '.png');
                        return(<div className={"flex-item-ver-center"}>
                            <Avatar src={iconUrl?iconUrl.default:''} size="small" title={name} />
                            <div className={'margin-left-5'}>
                                <p>{record.accountName}</p>
                                <p><span className={"color-grey"}>{name}</span></p>
                            </div>
                        </div>)}
                },
                {
                    cnTitle: '推广客户数',
                    cnTitleId: 'TuiGuangKeHuShu',
                    dataIndex: 'buyerCount',
                },
                {
                    cnTitle: '下级分销商',
                    cnTitleId: 'XiaJiFenXiaoShang',
                    dataIndex: 'twoLevelUserCount',
                    render: (num, record) => {
                        return(<div>
                                {/*下级分销商用户数 */}
                                <p>{num}</p>
                                {/* 下级分销商推广客户数 */}
                            <p className={"flex-item-ver-center"}><IconFont type={'icon-yonghu'} className={"font-16 color-light-grey"} /><span  className={"color-grey margin-left-5"}>{record.twoLevelUserBuyerCount}</span></p>
                        </div>)}
                },
                {
                    cnTitle: '累计佣金',
                    cnTitleId: 'LeiJiYongJin',
                    dataIndex: 'commissionTotal',
                    type:"money",
                    showSymbol: 'currencySymbol',
                },
                {
                    cnTitle: '推荐人',
                    cnTitleId: 'TuiJianRen',
                    dataIndex: 'inviter',
                },
                {
                    cnTitle: '类型&状态',
                    cnTitleId: 'LeiXingZhuangTai',
                    dataIndex: 'status',//todo
                    render: (status, record) => {
                        let sType = ''
                        const types = __getDictMap('fx_user_type')||{};
                        if(!isEmptyObject(types)){
                            sType = !isEmpty(record.type)?types[record.type]:'';
                        }
                        return(<div>
                            {/* 分销商类型 */}
                            <p>{sType}</p>
                            {/* 分销商状态 fx_user_status :未激活NOT_ENABLED：灰色  |  启用VALID：绿色  |  停用INVALID：红色*/}
                            {status=='VALID'&&<Badge status="success" />}
                            {status=='INVALID'&&<Badge status="error" />}
                            {status=='NOT_ENABLED'&&<Badge status="default" />}
                        </div>)}
                },
                    {
                    cnTitle: '操作',
                    dataIndex: 'CaoZuo',
                    width: 100,
                    cnTitleId: 'CaoZuo',
                    render: (item = {}, record) => (<Space>
                        <Popover content={Lang({id: 'BianJi',default:'编辑'})}>
                            <Link className="link" to={
                                {
                                    pathname: '/distributor/edit',
                                    search: `?id=${record.id}`,
                                }
                            }>
                                <HoverIcon
                                    inactiveIcon="icon-rukudengjiicon"
                                    activeIcon="icon-rukudengjiicon-1" />
                            </Link>
                        </Popover>
                        <Popover content={Lang({id: 'TuiGuangXiangQing',default:'推广详情'})}>
                            <Link className="link" to={
                                {
                                    pathname: '/distributor/detail',
                                    search: `?id=${record.id}`,
                                }
                            }>
                                <HoverIcon
                                    inactiveIcon="icon-a-tuiguangxiangqing1"
                                    activeIcon="icon-tuiguangxiangqing-1" />
                            </Link>
                        </Popover>
                    </Space>)},
            ],
            selectOption:[
                {   id:1,
                    cnTitle: '按创建时间倒序',
                    cnTitleId: 'AnChangJianShiJianDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'createTime',
                },
                {   id:2,
                    cnTitle: '按推广客户数倒序',
                    cnTitleId: 'AnTuiGuangKeHuShuDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'buyerCount',
                },
                {   id:3,
                    cnTitle: '按推广客户数顺序',
                    cnTitleId: 'AnTuiGuangKeHuShuShunXu',
                    orderDirect:1,// 排序 0是desc,1是asc
                    orderCode:'buyerCount',
                },
                {   id:4,
                    cnTitle: '按下级分销商用户数倒序',
                    cnTitleId: 'AnXiaJiFenXiaoShangDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'twoLevelUserCount',
                },
                {   id:5,
                    cnTitle: '按累积佣金倒序',
                    cnTitleId: 'AnLeiJiYongJinDaoXu',
                    orderDirect:0,// 排序 0是desc,1是asc
                    orderCode:'commissionTotal',
                },
                {   id:6,
                    cnTitle: '按累积佣金顺序',
                    cnTitleId: 'AnLeiJiYongJinShunXu',
                    orderDirect:1,// 排序 0是desc,1是asc
                    orderCode:'commissionTotal',
                },
            ],
            curSelect:{},//当前选择排序
            totalTrucking:{}, //返回的统计
        }
    }
    fetchCallBack(res){
        const {success,valid,model} = res;
        if (success && valid) {
            this.setState({
                totalTrucking:model||{}
            })
        }else this.setState({
            totalTrucking: {}
        })
    }

    /**
     * 勾选 筛选
     * */
    onChangeSelect(value,selectOption){
        let curSelect={}
        if(value){
            curSelect = selectOption.find(item=>item.id==value)
        }else curSelect = selectOption[0];
        this.setState({
            curSelect:curSelect
        },()=> {
            this.onPageTemplateTableChild.handleFetch(1,{},true);
        })
    }
    /**
     * 搜索表格 搜索
     ***/
    getFormData(data={}) {
        // this.fetch(1,data)
        this.onPageTemplateTableChild.handleFetch(1,data);
    }
    searchReset(){
        this.setState({
            selectSeven: false
        },()=>this.onPageTemplateTableChild.handleFetch(1,{},false))
    }
    /**
     * 推广时间 搜索
     ***/
    specialHandleTime(map){
        if(map.time){
            map['createTimeStart'] = map.time[0].startOf('day').valueOf();
            map['createTimeEnd'] = dayjs(map.time[1]).add(1, 'days').startOf('day').valueOf(); //结束时间
            delete map['time'];
        }
        return map
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    goPage(sUrl) {
        this.props.history.push(sUrl);
    }
    render(){
        const { loading,searchFormOptions,columns,selectOption,totalTrucking,initialSearch} = this.state;
        let { curSelect} = this.state;
        const currPageName = Lang({id: "ZhuCeFenXiaoShang",default: "注册分销商"});
        if(isEmptyObject(curSelect))curSelect=selectOption[0];
        return (<Spin tip='loading' spinning={loading}>
                    <CommonBreadcrumb list={[{ name:currPageName}]}></CommonBreadcrumb>
                    <div className={'distributorListWrap'}>
                        <div className={'title fw_700 font_18'}>{currPageName}
                        </div>
                        {searchFormOptions.length>0&&<div className={'top-search'}>
                            <SearchForm
                                options = {searchFormOptions}
                                searchReset={(dat)=>this.searchReset(dat)}
                                pageSize={50}
                                flagShowReset={true}
                                initialValues={initialSearch}
                                flagShowSearchBtn={true}
                                // className={'search-form-grey'}
                                getSearchValue={this.getFormData.bind(this)} />
                        </div>}
                    </div>
                    <div className={'distributorListWrap'}>
                        <div className={"site-btn-action flex-item-between"}>
                            <div className={'flex-item-ver-center'}>
                                <span className={"flex-item-ver-center btn-add"} onClick={()=>this.goPage('/distributor/add')} title={Lang({id:'XinZengFenXiaoShang',default:'新增分销商'})}>
                                    <span className="icon iconfont icon-plus"></span>{Lang({id:'XinZengFenXiaoShang',default:'新增分销商'})}
                                </span>
                                <div className={"digital-box title-black font-weight-700 margin-left-5"}>{Lang({id: "ZongJi",default: "总计"})}
                                    <span>{Lang({id: "FenXiaoShang",default: "分销商"})}</span>{totalTrucking.fxDistributorUserTotal||0}
                                    <span>，{Lang({id: "YaoQingKeHu",default: "邀请客户"})}</span>{totalTrucking.invitationBuyerTotal||0}
                                    <span>，{Lang({id: "YouXiaoKeHu",default: "有效客户"})}</span>{totalTrucking.authBuyerTotal||0}
                                </div>
                            </div>
                            <Select placeholder={Lang({id:curSelect.cnTitleId,default:curSelect.cnTitle})}
                                    onChange={(value)=>this.onChangeSelect(value,selectOption)}>
                                {selectOption.map(item=><Option key={item.id} value={item.id}>{Lang({id:item.cnTitleId,default:item.cnTitle})}</Option>)}
                            </Select>
                        </div>
                        <AutoFetchTable columns={columns}
                                        onRef={this.onRefTabOne}
                                        flagShowReset={false}
                                        flagShowSearchBtn={false}
                                        specialHandle={this.specialHandleTime}
                                        pageSize={50}
                                        precondition={{...initialSearch,
                                            orderDirect:curSelect.orderDirect, //排序 0是desc,1是asc
                                            orderCode:curSelect.orderCode, // 排序字段  createTime:创建时间 ; buyerCount:推广客户数 ; twoLevelUserCount:下级分销商用户数; commissionTotal:累积佣金
                                        }}
                                        fetchCallBack={(res)=>this.fetchCallBack(res)}
                                        showQuickJumper={false}
                                        fetchApi={'/service/mg/distributor/list'} />
                    </div>
            </Spin>

        )
    }
}

export default DistributorList;
